export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-voronoi/index.js
// module id = ../../../../d3-voronoi/index.js
// module chunks = 3